<template>
  <div>
    <loading-screen :is-loading="isLoading"></loading-screen>
    <v-app style="background-color:#EEEEEE;"> 
    <Navigation />
    <v-content>
      <router-view/>
    </v-content>
    <CompFooter />
  </v-app>
  </div>  
</template>

<script>
import Navigation from '@/components/Navigation'
import CompFooter from '@/components/Footer'
import Loader from '@/components/Loader'
export default {
  name: 'App',
  components:{Navigation,CompFooter,'loading-screen': Loader},
  mounted () {
    setTimeout(() => {
      this.isLoading = false
    }, 4000)
  },
  data(){
    return {
      isLoading: true,
    }
  },
};
</script>
<style lang="scss" scoped>
.v-content{
  padding: 0 !important;
}
</style>
<style lang="scss">
</style>